import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({name: 'sequence'})
export class SequencePipe implements PipeTransform {

  constructor(private Translate: TranslateService) {
  }

  transform(input: string[]): string {
    const arr = (input || []).slice();
    const end = arr.splice(-2).join(this.Translate.instant('sequence.or'));
    return arr.join(this.Translate.instant('sequence.comma')) + end;
  }
}
